<div class="gridItemChildModule w-100 h-100 d-flex flex-column pr-3" id="performance-body"
    [class.pr-3]="!noData && toggleDisplayView === displayViewOption.TABLE" #widgetRef>
    <!-- Error Views -->
    <app-module-error class="flex-fill" *ngIf="noData && toggleDisplayView === displayViewOption.TABLE"
        [noData]="true"></app-module-error>
    <!-- Content -->
    <div class="d-flex flex-column position-relative">
        <!--  Search -->
        <div *ngIf="!config.isCxOne && dataLoadSuccess && !noData" class="mx-auto my-2 search-box live-search"
            [hidden]="!showFilter">
            <input #searchBox type="search" class="form-control" autocomplete="off" [(ngModel)]="filterValue"
                (ngModelChangeDebounced)="applyFilter()" [ngModelChangeDebounceTime]="500" placeholder="Search..."
                cvLocalizedPlaceholder [langSection]="'Subscriptions_Management'" [langKey]="'Search'" />
            <span class="clear-input" role="button" tabindex="0" [hidden]="filterValue.length === 0"
                (click)="clearFilter()">
            </span>
        </div>
        <!-- Search cxone -->
        <div *ngIf="config.isCxOne && dataLoadSuccess && !noData" class="cxone-live-search ml-2 my-2"
            [hidden]="!showFilter">
            <cxone-text-input [(ngModel)]="filterValue" [placeholder]="searchPlaceholder" (keyup)="applyFilter()"
                class="cxone-widget-search" name="cxoneInput-{{moduleKey}}" (ngModelChangeDebounced)="filterValue"
                [ngModelChangeDebounceTime]="500">
            </cxone-text-input>
            <i class="cxone-search-icon" [hidden]="filterValue.length !== 0">
                <svg class="icon-18 fill-iconDefault-noHover cxone-search-wrapper">
                    <use href="../App_Themes/CXone/icons/search.svg#search"></use>
                </svg>
            </i>
            <i [hidden]="filterValue.length === 0" (click)="clearFilter()">
                <svg class="icon-18 fill-iconDefault-noHover cxone-close-wrapper">
                    <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                </svg>
            </i>
        </div>
    </div>
    <!-- cell render custom -->
    <div class="flex-fill" style="min-height: 0;">
        <ng-template #completedDisplay let-display="display" let-completed="completed" let-pending="pending"
            let-expired="expired" let-deleted="deleted" let-replaced="replaced">
            <div #pop="ngbPopover" style="text-align: left;" (mouseover)="pop.open()" (mouseleave)="pop.close()"
                placement="right" container="body" [ngbPopover]="popoverContent">{{ display }}</div>
            <ng-template #popoverContent>
                <div>
                    <b>{{cvLocalizationService.getCachedText('Evaluator_Performance', 'Completed', 'Completed')}}:
                        {{ completed.MetricValue }}</b>
                </div>
                <div>{{cvLocalizationService.getCachedText('Evaluator_Performance', 'Pending', 'Pending')}}: {{
                    pending.MetricValue }}</div>
                <div>{{cvLocalizationService.getCachedText('Evaluator_Performance', 'Expired', 'Expired')}}: {{
                    expired.MetricValue }}</div>
                <div>{{cvLocalizationService.getCachedText('Evaluator_Performance', 'Deleted', 'Deleted')}}: {{
                    deleted.MetricValue }}</div>
                <div>{{cvLocalizationService.getCachedText('Evaluator_Performance', 'Replaced', 'Replaced')}}: {{
                    replaced.MetricValue }}</div>
            </ng-template>
        </ng-template>

        <ng-template let-row="rowInfo" #completedTemplate>
            <ng-container [ngTemplateOutlet]="completedDisplay" [ngTemplateOutletContext]="{
            display: row.rowData.Completed.CompletedDisplayValue,
            completed: row.rowData.Completed.MetricDatas['Completed'],
            pending: row.rowData.Completed.MetricDatas['Pending'],
            expired: row.rowData.Completed.MetricDatas['Expired'],
            deleted: row.rowData.Completed.MetricDatas['Deleted'],
            replaced: row.rowData.Completed.MetricDatas['Replaced']
            }"></ng-container>
        </ng-template>
    </div>
    <!-- Table -->
    <div *ngIf="gridOptions !== null && dataLoadSuccess && !noData && toggleDisplayView === displayViewOption.TABLE"
        class="w-100 h-100">
        <ag-grid-angular #evaluatorPerformanceWidgetGrid class="ag-theme-balham flex-fill" [gridOptions]="gridOptions">
        </ag-grid-angular>
    </div>
    <!-- Pie chart -->
    <div *ngIf="isResizingModule && toggleDisplayView === displayViewOption.COMPARISON" class="h-100 w-100">
        <div class="h-100 w-100 pieChartModule">
            <div class="evaluator-dropdown-row row" [class.widget-padding]="widgetRef.clientWidth > 600"
                [class.p-2]="widgetRef.clientWidth < 601">
                <div class="col-6" [class.p-2]="widgetRef.clientWidth > 600">
                    <cxone-singleselect-dropdown class="evaluator-dropdown" id="first-evaluator-dropdown"
                        [placeholder]="evaluatorDropdownPlaceholder" [label]="'label'" (onLoadData)="onLoadData()"
                        [enableInfiniteScroll]="true" [primaryKey]="'label'" [isLoading]="loading"
                        [maxItemsToDisplay]="dataLimit" [sortOrder]="'asc'"
                        (selectionChanged)="selection1Changed($event)" [(ngModel)]="firstEvaluatorDropdown"
                        [options]="evaluatorDropdownOptions" [showFooter]="false" [search]="true"
                        [serverSideSearch]="serverSideOptions" (onServerSideSearch)="onSearch($event)"
                        (dropdownClosed)="onCloseDropdown()">
                    </cxone-singleselect-dropdown>
                </div>
                <div class="col-6" [class.p-2]="widgetRef.clientWidth > 600">
                    <cxone-singleselect-dropdown class="evaluator-dropdown" id="second-evaluator-dropdown"
                        [placeholder]="evaluatorDropdownPlaceholder" [label]="'label'" (onLoadData)="onLoadData()"
                        [enableInfiniteScroll]="true" [primaryKey]="'label'" [isLoading]="loading"
                        [maxItemsToDisplay]="dataLimit" [sortOrder]="'asc'"
                        (selectionChanged)="selection2Changed($event)" [(ngModel)]="secondEvaluatorDropdown"
                        [options]="evaluatorDropdownOptions" [showFooter]="false" [search]="true"
                        [serverSideSearch]="serverSideOptions" (onServerSideSearch)="onSearch($event)"
                        (dropdownClosed)="onCloseDropdown()">
                    </cxone-singleselect-dropdown>
                </div>
            </div>
            <ng-container *ngTemplateOutlet="comparisonData"></ng-container>
        </div>
    </div>
    <!-- Line chart -->
    <div *ngIf="toggleDisplayView === displayViewOption.COMPLETED_EVALUATIONS_TREND" class="h-100 w-100">
        <div class="evaluator-trend-dropdown-row pl-2 pt-2 row">
            <div class="col-6 d-flex justify-content-start">
                <cxone-singleselect-dropdown class="evaluator-dropdown" id="first-evaluator-dropdown"
                    [placeholder]="evaluatorDropdownPlaceholder" [label]="'label'" (onLoadData)="onLoadData()"
                    [enableInfiniteScroll]="true" [primaryKey]="'label'" [isLoading]="loading"
                    [maxItemsToDisplay]="dataLimit" [sortOrder]="'asc'" (selectionChanged)="selection3Changed($event)"
                    [(ngModel)]="lineChartEvaluatorDropdown" [options]="evaluatorDropdownOptions" [showFooter]="false"
                    [search]="true" [serverSideSearch]="serverSideOptions" (onServerSideSearch)="onSearch($event)"
                    (dropdownClosed)="onCloseDropdown()">
                </cxone-singleselect-dropdown>
            </div>
        </div>
        <cv-qm-evaluator-performance-trend #trendLineChart [chartData]="chartData3"></cv-qm-evaluator-performance-trend>
    </div>
</div>
<ng-template #noComparisonData>
    <div class="empty-container">
        <svg>
            <use href="../App_Themes/CXone/icons/empty.svg#empty"></use>
        </svg>
        <span class="info" cvLocalizedText langSection="Evaluator_Performance" langKey="No_Evaluators">
            No evaluators selected yet
        </span>
    </div>
</ng-template>

<ng-template #comparisonData>
    <div *ngIf="isResizingModule" class="w-100" style="height: 82%;"
        [class.widget-padding]="widgetRef.clientWidth > 600">
        <div class="row" id="row-container"
            [style.height]="(firstEvaluatorDropdown || secondEvaluatorDropdown) ? '85%' : '100%'">
            <div class="col-6 h-100 w-100" *ngIf="isResizingModule">
                <ng-container *ngIf="firstEvaluatorDropdown">
                    <cv-qm-evaluator-performance-comparison #chart1 [chartData]="chartData1" [legendData]="chartLegends"
                        (chartRef)="setChartObj($event)">
                    </cv-qm-evaluator-performance-comparison>
                </ng-container>
                <ng-container *ngIf="!firstEvaluatorDropdown">
                    <ng-container *ngTemplateOutlet="noComparisonData"></ng-container>
                </ng-container>
            </div>
            <div class="col-6 h-100 w-100" *ngIf="isResizingModule">
                <ng-container *ngIf="secondEvaluatorDropdown">
                    <cv-qm-evaluator-performance-comparison #chart2 [chartData]="chartData2" [legendData]="chartLegends"
                        (chartRef)="setChartObj($event)">
                    </cv-qm-evaluator-performance-comparison>
                </ng-container>
                <ng-container *ngIf="!secondEvaluatorDropdown">
                    <ng-container *ngTemplateOutlet="noComparisonData"></ng-container>
                </ng-container>
            </div>
        </div>
        <ng-container *ngIf="showLegends">
            <div #chartContainer class="row mb-3 mt-1 ml-0 w-100 justify-content-center"
                *ngIf="firstEvaluatorDropdown || secondEvaluatorDropdown"
                [style.height]="widgetRef.clientHeight < 330 ? '15%' : '75px'"
                [class.legends-container]="widgetRef.clientWidth < 601"
                [class.legends-padding]="widgetRef.clientWidth > 600">
                <div *ngFor="let item of chartLegends; index as i" [class.strike-line]="item.toggleLegend === true"
                    (click)="toggleLegend(item)" class="p-1 d-flex cursor-pointer {{item.className}}"
                    style="align-items: center; height: fit-content;">
                    <span class="colors mr-1" id="color-slices">
                        <span id="color-slice-{{i}}" class="color"
                            [ngStyle]="{'background': !item.toggleLegend ? item.color : 'rgba(5, 19, 26, 0.48)'}"></span>
                    </span>

                    <span title="{{item.label}}">
                        {{item.label}}
                    </span>
                </div>
            </div>
        </ng-container>
    </div>
</ng-template>